
import { mapGetters, mapMutations, mapState } from 'vuex';
import SingleSelect from '@/components/ui/singleSelect.vue';
import Row from '@/components/shop/row.vue';

export default {
  name: 'OrderSummary',

  components: {
    Row,
    SingleSelect,
  },

  props: {
    sub: {
      type: Boolean,
      default: true,
    },
    cart: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      zip: null,
      isStorePickup: false, // process.env.REGION === 'AO',
    };
  },

  computed: {
    ...mapGetters(['subTotal', 'freeShipping']),
    ...mapState(['order', 'calculatedShipping', 'regions']),

    total() {
      const orderPrice = this.order?.price ?? this.subTotal;
      const shippingCost =
        this.freeShipping || this.order?.shipping
          ? 0
          : this.calculatedShipping?.shipping ?? 0;

      return orderPrice + shippingCost;
    },
  },

  async mounted() {
    if (this.isAngola) {
      const { data: regions } = await this.$bolev.getRegions();
      this.setRegions(regions);
    }
  },

  methods: {
    ...mapMutations(['setCalculatedZip', 'setRegions']),

    handleZip() {
      this.setCalculatedZip(this.zip);
      this.$emit('updateShipping', true);
    },
  },
};
